import React, { CSSProperties, FC } from 'react'

import styled from 'styled-components'

import featuredPhotosX3SizeMImage from './assets/featured-photos-x3-size-m.png'
import featuredPhotosX3SizeSImage from './assets/featured-photos-x3-size-s.png'
import featuredPhotosX3SizeXsImage from './assets/featured-photos-x3-size-xs.png'
import { TimerSizeMSvg } from './assets/TimerSizeMSvg'
import { TimerSizeSSvg } from './assets/TimerSizeSSvg'
import { TimerSizeXsSvg } from './assets/TimerSizeXsSvg'
import { FeaturedPhotosX3PromoTimer } from './FeaturedPhotosX3PromoTimer'
import { useFeaturedPhotosPromoX3 } from './hooks/useFeaturedPhotosPromoX3'

type Size = 'M' | 'S' | 'XS'

export const FeaturedPhotosPromoX3: FC<{
  size: Size
  rootStyle?: CSSProperties
}> = ({ size, rootStyle }) => {
  const { promoEndDate } = useFeaturedPhotosPromoX3()

  const counterElement = <FeaturedPhotosX3PromoTimer endDate={promoEndDate!} />

  switch (size) {
    case 'M':
      return (
        <ImageSizeM
          style={{
            ...rootStyle,
            backgroundImage: `url(${featuredPhotosX3SizeMImage})`,
          }}
          counter={counterElement}
        />
      )
    case 'S':
      return (
        <ImageSizeS
          style={{
            ...rootStyle,
            backgroundImage: `url(${featuredPhotosX3SizeSImage})`,
          }}
          counter={counterElement}
        />
      )
    case 'XS':
      return (
        <ImageSizeXs
          style={{
            ...rootStyle,
            backgroundImage: `url(${featuredPhotosX3SizeXsImage})`,
          }}
          counter={counterElement}
        />
      )
  }
}

const ImageSizeM = styled(TimerSizeMSvg)`
  width: 100%;
  height: 100%;
  max-width: 250px;
  max-height: 135px;
  background-size: contain;
  background-repeat: no-repeat;

  @media (max-height: 550px) {
    width: 200px;
    height: 100%;
  }
`
const ImageSizeS = styled(TimerSizeSSvg)`
  width: 100%;
  height: 100%;
  max-width: 250px;
  max-height: 102px;
  background-size: contain;
  background-repeat: no-repeat;
`
const ImageSizeXs = styled(TimerSizeXsSvg)`
  margin: -10px auto 10px;
  background-size: contain;
  background-repeat: no-repeat;
`
